<template>
  <div class="ProductCenter">
    <!-- 菜单+banner -->
<!--    <caidan></caidan>-->
<!--    <div class="CaiDanBottom"></div>-->
<!--    <div class="banner-container">-->
<!--      <img class="img-about" src="@/assets/product/top-img.42c6afdf.jpg" >-->
<!--    </div>-->
    <!-- 面包屑 -->
    <productBreadCrumb class="productBreadCrumb"></productBreadCrumb>
    <!-- 产品选择页面 -->
    <div class="content-container">

      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import caidan from "@/components/caidan.vue";
import productBreadCrumb from "@/components/productBreadCrumb.vue";

export default {
  name: 'ProductCenter',
  components: {
    caidan,
    productBreadCrumb
  },
  methods: {
    isActive(path) {
      return this.$route.path.startsWith(path);
    },
    navigateTo(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style scoped>
.ProductCenter {
  width: 100%;
}
.productBreadCrumb{
  display: none;
}
.banner-container {
  width: 100%;
  height: 350px;
  overflow: hidden;
  position: relative;

  display: block;
  background-color: white;
}
@media screen and (max-width: 768px) {
  .banner-container {

    height: auto;

  }
  .CaiDanBottom{
    height:10vw;
    width: 100%;
  }
}
.img-about {
  width: 100%;
  display: block;
  height: auto;
  max-width: none;
}

.content-container {
  width: 100%;

}

.container2-FnBox {
  width: 100%;
  max-width: 1200px;
  margin: 20px auto 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;
  min-height: 600px;
}

.container2-FnBox > div {
  flex: 1;
  min-width: 300px;
  max-width: calc(50% - 10px);
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
  transition: transform 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.container2-FnBox > div:hover {
  transform: translateY(-5px);
}

@media screen and (max-width: 768px) {
  .content-container {
    width: 100%;
  }

  .container2-FnBox {
    width: 95%;
    min-height: auto;
  }

  .container2-FnBox > div {
    min-width: 100%;
    max-width: 100%;
  }
}
</style>
